// extracted by mini-css-extract-plugin
export default {"main":"MainShare_main__QQwIv","content":"MainShare_content__bKsbP","blueLink":"MainShare_blueLink__7gMUQ"};